import { DrugItem, FetchAttr } from '../types';
import { getData } from '../utils';

type GetDrugsByIdsRequest = {
  ids: string[];
};

type GetDrugsByIdsResponse = DrugItem[];

const getMultipleDrugs = async (
  requestObj: GetDrugsByIdsRequest,
  attr?: FetchAttr
): Promise<GetDrugsByIdsResponse> => {
  const { ids } = requestObj;
  if (!ids || ids?.length === 0) {
    // Do not fetch API if requested list of ids is empty
    return [];
  }
  const response = await getData(`drug?ids=${ids}`, attr);
  return response;
};

export default getMultipleDrugs;
